import React from "react";
import AllBooks from "../AllBooks/AllBooks";

const Home = () => {
  return (
    <div className="container">
      <div className="m-2">
        <div className="d-flex justify-content-center">
          <input
            className="form-control"
            type="text"
            placeholder="Search book..."
          />
          <button className="btn btn-primary">Search</button>
        </div>
      </div>
      <AllBooks></AllBooks>
    </div>
  );
};

export default Home;
